module.exports = __webpack_public_path__ + "static/media/soc-yt-white.021cb1b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/soc/soc-yt-white.svg
// module id = 936
// module chunks = 270